import { toast } from "react-toastify";
import { Trans } from "react-i18next";
import PropTypes from "prop-types"

const ToasterNotification = ({
    type,
    message,
    i18keyFormat,
    options,
}) => {

    if(options?.dismiss){
        toast.dismiss();
    }

    const defaultOptions = {
        position: options?.position || "top-right",
        autoClose: options?.autoClose || 5000,
        hideProgressBar: options?.hideProgressBar ?? false,
        closeOnClick: options?.closeOnClick ?? true,
        pauseOnHover: options?.pauseOnHover ?? false,
        draggable: options?.draggable ?? false,
        pauseOnFocusLoss: options?.pauseOnFocusLoss ?? false,
        ...options,
    };

    const TransMessage = (
        <div>
            <Trans i18nKey={i18keyFormat} defaults={message} />
        </div>
    );
    switch (type) {
        case "success":
            toast.success(TransMessage, defaultOptions);
            break;
        case "error":
            toast.error(TransMessage, defaultOptions);
            break;
        case "info":
            toast.info(TransMessage, defaultOptions);
            break;
        case "warning":
            toast.warn(TransMessage, defaultOptions);
            break;
        default:
            toast(TransMessage, defaultOptions);
    }
};

export default ToasterNotification
